<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form-row @keyup.enter="load">

                    <b-col cols="3">
                        <LgFinderPageUnidadeAdministrativa :prefix="prefix + title + ' > '" v-model="form.departamento"
                            label="Departamento:" required @onselect="handleSelectUnidadeAdministrativa" />
                    </b-col>

                    <b-col cols="3">
                        <LgFinderPageLocalArmazenamento :prefix="prefix + title + ' > '" v-model="form.local"
                            label="Local Armazenamento:" required @input="handleLocal" />
                    </b-col>

                    <b-col cols="3">
                        <LgFinderPageLeitor :prefix="prefix + title + ' > '" v-model="form.leitor" label="Leitor:"
                            required @close="handleLeitor" />
                    </b-col>
                    <b-col cols="2" class="mt-2">
                        <b-button id="limpar" class="my-2" size="sm" style="height: 40px" pill variant="primary"
                            @click="limpar">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="eraser" />
                            </div>
                            <b-tooltip target="limpar" title="Limpar"></b-tooltip>
                        </b-button>


                        <b-button id="localizarDepartamentoLocalLeitorMonitoramento" class="mr-2 my-2" size="sm"
                            style="height: 20px" pill variant="primary" @click="load()">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" /> &nbsp;
                            </div>
                            <b-tooltip target="localizarDepartamentoLocalLeitorMonitoramento"
                                title="Localizar"></b-tooltip>

                        </b-button>

                    </b-col>


                    <b-col cols="1" class="text-right mt-2">


                        <b-button id="novoDepartamentoLocalLeitorMonitoramento" class=" my-2" size="sm"
                            style="height: 20px" pill variant="primary" @click="mostrarModal">
                            <div class="btn-size-alinhamento">
                                <b-icon scale="1" icon="plus" /> &nbsp;
                            </div>
                            <b-tooltip target="novoDepartamentoLocalLeitorMonitoramento"
                                title="Adicionar novo..."></b-tooltip>

                        </b-button>

                    </b-col>
                </b-form-row>
                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" :hover="true" show-empty
                    @row-dblclicked="departamentoLocalLeitorMonitoramentoArmazenamentoSelect">

                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>


                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>

                    <template v-slot:cell(antena)="row">
                        {{ row.item.antena + (row.item.descricaoAntena? (" - " + row.item.descricaoAntena ): "") }}
                    </template> 
                    <template v-slot:cell(remover)="row">
                        <b-button :id="row.index + 'excluir'" class="my-2" size="sm" pill variant="primary"
                            @click="remove(row.item)" v-b-tooltip.hover.bottom="'Excluir'">
                            <b-icon icon="trash-fill" />
                        </b-button>

                    </template>
                    <template v-slot:cell(action)="row">

                        <b-button :id="row.index + 'edit-button'" class="my-2" size="sm" pill variant="primary"
                            @click="editar(row.item)" v-b-tooltip.hover.bottom="'Editar'">
                            <b-icon icon="pencil-square" />
                        </b-button>


                    </template>


                </b-table>
                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>

        <DepartamentoLocalLeitorMonitoramentoArmazenamentoForm v-if="show" @close="cancelar"
            :prefix="prefix + title + ' > '" :id="id" />


    </b-card>
</template>

<script>
import ResourceService from "@/core/api/ResourceService";
import { ListResourceMixin } from "@/core/mixins/resource";
import DepartamentoLocalLeitorMonitoramentoArmazenamentoForm from "./DepartamentoLocalLeitorMonitoramentoArmazenamentoForm.vue";
import ConfirmMixin from "@/core/mixins/confirm"
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue";
import LgFinderPageLocalArmazenamento from "@/components/Finders/LgFinderPageLocalArmazenamento.vue";
import LgFinderPageLeitor from "@/components/Finders/LgFinderPageLeitor.vue";

export default {
    components: {
        DepartamentoLocalLeitorMonitoramentoArmazenamentoForm,
        LgFinderPageLeitor,
        LgFinderPageLocalArmazenamento,
        LgFinderPageUnidadeAdministrativa
    },
    props: {
        prefix: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            title: 'Departamento-Local-Leitor',
            id: null,
            show: false,
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            filtro: "",
            form: {
                departamento: {},
                local: {},
                leitor: {}
            },
        };
    },
    mixins: [ListResourceMixin, ConfirmMixin],
    beforeMount() {
        this.$service = new ResourceService(`/api/leitor-monitoramento`);
        const brand = JSON.parse(localStorage.getItem("context"))
        this.form.departamento = brand.departamento

    },
    mounted() {
        this.load();
    },
    watch: {
        page() {
            this.load();
        },
    },
    computed: {
        tableFields() {
            return [
                { key: "departamento", label: "Departamento" },
                { key: "local", label: "Local Armazenamento" },
                { key: "leitor", label: "Leitor" },
                { key: "antena", label: "Antena" },
                { key: "action", label: " ", tdClass: "w-1" },
                { key: "remover", label: " ", tdClass: "w-1" },

            ];
        },
    },
    methods: {
        async remove(item) {
            await this.$removeResource(item)
        },
        handleLeitor(leitor) {
            this.form.leitor = leitor;
            this.load();
        },
        handleLocal(local) {
            this.form.local = local;
            this.load();

        },
        handleSelectUnidadeAdministrativa(departamento) {
            this.form.departamento = departamento;
            this.load();

        },

        limpar() {
            this.form.departamento = {};
            this.form.local = {};
            this.form.leitor = {};
            this.load();
        },
        async editar(item) {
            this.id = item.id;
            this.show = true;
        },
        async load() {
            this.filtro = {};
            this.busy = true;

            if (this.form.departamento && this.form.departamento.id)
                this.filtro.departamento = this.form.departamento.id;

            if (this.form.local && this.form.local.id)
                this.filtro.local = this.form.local.id;

            if (this.form.leitor && this.form.leitor.id)
                this.filtro.leitor = this.form.leitor.id;

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,

            });

        },
        cancelar() {
            this.id = null;
            this.show = false;
            this.load();
        },
        mostrarModal() {
            this.id = null;
            this.show = true;
        },

        async departamentoLocalLeitorMonitoramentoArmazenamentoSelect(item) {
            this.$emit("close", item);
        },

    },
};
</script>
